import { PlanningQuestion } from '../../../../types/work';

/** Sentinel for the "Other (specify below)" radio/checkbox option. */
export const FREE_TEXT_OPTION = '__free_text__';

/** Unified per-question answer shape — works for both single- and
 *  multi-select questions (single keeps at most one entry in
 *  ``selected``). ``freeText`` is populated when the user picks
 *  ``FREE_TEXT_OPTION``. */
export interface Answer {
    selected: Set<string>;
    freeText: string;
}

export const initAnswers = (
    questions: PlanningQuestion[]
): Record<number, Answer> =>
    questions.reduce(
        (acc, _, idx) => ({
            ...acc,
            [idx]: { selected: new Set<string>(), freeText: '' }
        }),
        {}
    );
